<template>
    <div>
        <div
            class='w-100 p-2 text-center rounded-top'
            :style="$bgColor(color.primary)"
        >
            <div class='gamification-points-header'>
                <h3
                    class='card-title mt-2 mr-2 mb-0 plan-title'
                    :style="{ color: color.secondary }"
                >
                    {{ planName }}
                </h3>
                <h3
                    class='card-title mt-2 ml-2 mb-0 total-points'
                    :style="{
                        color: color.secondary,
                        borderColor: color.secondary, 
                    }"
                >
                    {{ $t('gamification.gamification_total_points', { points: studentPlanGoals.total_points ? studentPlanGoals.total_points : 0 }) }}
                </h3>
            </div>
        </div>
        <card class='container rounded-bottom'>
            <div class="w-100">
                <div
                    v-if="studentPlanGoals.goals.length > 0"
                >
                    <table>
                        <tr>
                            <th>{{ $t('gamification.gamification_content_name') }}</th>
                            <th>{{ $t('gamification.gamification_finish_date') }}</th>
                            <th>{{ $t('gamification.gamification_score') }}</th>
                        </tr>
                        <tr
                            v-for="(goals, i) in studentPlanGoals.goals"
                            :key="i"
                        >
                            <td>{{ goals.name ? goals.name : $t(`gamification.${goals.goal_type}_title`) }}</td>
                            <td>{{ $moment(goals.updated_at).format('LLL') }}</td>
                            <td>{{ goals.points }}</td>
                        </tr>
                    </table>
                </div>
                <div
                    v-else
                    class="plan-without-progress"
                >
                    {{ $t('gamification.gamification_content_without_progress') }}
                </div>
            </div>
        </card>
    </div>
</template>
    
<script>
import Card from '../../argon/components/Cards/Card';
    
export default {
    name: 'GamificationHoleProgress',

    components: {
        Card,
    },

    props: {
        gamificationRules: Object,
        color: {
            type: Object,
            required: true,
        },
        student: {
            type: Object,
            required: true,
        },
        plan: Object,
        planName: String,
    },

    data() {
        return {
            studentPlanGoals: null,
        };
    },

    methods: {
        async getStudentGoals(planId) {
            return window.axios
                .get(`/api/gamification/goals/student/${this.student.id}/plan/${planId}`)
                .then(response => {
                    this.studentPlanGoals = response.data.data;
                    const goals = response.data.data.goals[0];
                    var newGoals = goals.attendance
                        .filter(item => item.points > 0)
                        .concat(
                            goals.certificates.filter(item => item.points > 0),
                            goals.courses.filter(item => item.points > 0),
                            goals.exercises.filter(item => item.points > 0),
                            goals.lessons.filter(item => item.points > 0),
                            goals.modules.filter(item => item.points > 0),
                            goals.surveys.filter(item => item.points > 0)
                        );
                    // Ordena o array para que esteja em ordem crescente
                    newGoals.sort((a, b) => {
                        let dateA = new Date(a.updated_at).getTime();
                        let dateB = new Date(b.updated_at).getTime();
                        return dateA - dateB;
                    });
                    this.studentPlanGoals.goals = newGoals;
                })
                .catch(err => {
                    this.$store.commit('SET_NOTIFICATION', {
                        message: err.response.data.error,
                        status: 'error'
                    });
                    this.$emit('error', false)
                })
        },
    },

    async mounted() {
        // Verifica se o aluno e os planos estão definidos para então buscar as metas
        // do aluno
        if (this.student && this.plan) {
            await this.getStudentGoals(this.plan.id);
        }
    }
};
</script>
    
<style scoped>
    .plan-without-progress {
        text-align: center;
    }

    .plan-title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 560px;
    }

    .total-points {
        border-left: 3px solid #000;
        padding-left: 15px;
    }

    .gamification-points-header {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .card-title {
        font-size: 20px;
        font-weight: bold;
    }

    .rounded-top {
        border-top-left-radius: 25px !important;
        border-top-right-radius: 25px !important;
    }

    .rounded-bottom {
        border-bottom-left-radius: 25px !important;
        border-bottom-right-radius: 25px !important;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 10px 5px;
        text-align: center;
        color: #000;
    }

    th {
        background-color: #f2f2f2;
        font-size: 15px;
    }
</style>
    